import { DEFAULT_FIELD_EXCEPTIONS } from '../constants';
import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type {
    ContentTypeProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

const _findAllFancy = async function _findAllFancy<T>(
    contentType: ContentTypeProps,
    enableLivePreview: boolean,
    lang: LocaleProps,
    only?: string[],
): Promise<T> {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        const allResults: T[] = [];
        let hasMore = true;
        const limit = 100;

        for (let skip = 0; hasMore; skip += limit) {
            let query = stackClient.stack
                .ContentType(contentType)
                .Query()
                .limit(limit)
                .skip(skip);

            if (only && only.length > 0) {
                query = query.only(only);
            } else {
                query = query.except(DEFAULT_FIELD_EXCEPTIONS);
            }

            query = query.includeCount().language(lang).toJSON();

            const [entries, totalCount] = await query.find();

            allResults.push(...entries);

            hasMore = totalCount > allResults.length;
        }

        return allResults as T;
    } catch (err) {
        throw new Error(
            `An error occurred in _findAllFancy: ${JSON.stringify(err)}`,
        );
    }
};

const cached_findAllFancy = unstable_cache(
    _findAllFancy,
    ['search_findAllFancy'],
    {
        revalidate: 10800, // 3 hours
    },
);

export const findAllFancy = async function findAllFancy<T>(
    contentType: ContentTypeProps,
    enableLivePreview: boolean,
    lang: LocaleProps,
    only?: string[],
): Promise<T[]> {
    const fn =
        typeof window === 'undefined' ? cached_findAllFancy : _findAllFancy;

    return fn(contentType, enableLivePreview, lang, only);
};
